import React from 'react';
import { useSelector } from 'react-redux';
import  ExhibitorCardComponent from './components/ExhibitorCard';

export const ExhibitorCard = (props) => {
  const plan = useSelector(state => state.plan);
  return (
    <ExhibitorCardComponent {...props} plan={plan} />
  );
}